import React from "react";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonTitle,
  IonContent
} from "@ionic/react";
import { arrowBack } from "ionicons/icons";
import { IonIcon } from "@ionic/react";
import { TowingPlaneList } from "../../towingPlane/TowingPLaneList";

/**
 * Towing plane selection view component
 */
export const TowingPlaneSelectionView = ({
  type,
  active,
  onBack,
  onSelectPlane
}) => {
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons>
            <IonButton slot="start" color="primary" onClick={onBack}>
              <IonIcon icon={arrowBack} /> Zpět
            </IonButton>
            <IonTitle>Vyber vlečnou</IonTitle>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <TowingPlaneList
          key="planeList"
          type={type}
          setPlane={onSelectPlane}
          active={active?.towingPlane}
        />
      </IonContent>
    </IonPage>
  );
};

